import React from "react";
import "./RefMenu.scss";
import { NavLink } from "react-router-dom";
import NetsLogo from "../../../../UI/NetsLogo/NetsLogo";
const RefMenu = ({menuLink}) => {
  return (
    <div className="refMenu_container">
      <div className="refMenu_block">
        <NavLink to={'/'} >
        <NetsLogo />
        </NavLink>
        <div className="refMenu_item">
          {
            menuLink?.map((e)=> 
              e.vps ? <NavLink to={e.link} key={`${e.id}-${e.link}`}>{e.name}</NavLink> : <a href={e.link} key={`${e.id}-${e.link}`}>{e.name}</a>
            )
          }
           
        </div>
      </div>
      <div className="refMenuSearch_block">
        <NavLink to={'/login'}><button>Войти</button></NavLink>
      </div>
    </div>
  );
};

export default RefMenu;
